import { generatePath } from 'quartz-routing/react-router';
const PLAYLIST_URL_FRAGMENT = '/saved-items/playlists/:playlistId';
export const getPlaylistUrl = playlistId => {
  const pathname = generatePath(PLAYLIST_URL_FRAGMENT, {
    playlistId
  });
  const search = '';
  return {
    search,
    pathname,
    hash: '',
    fullUrl: `${pathname}${search ? `?${search}` : ''}`
  };
};